import { Card, CardMedia, Box, Button } from "@mui/material";
import React from "react";
import { FileDownloadOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { alertIcons } from "../../../../../assets/icons/icons";

export interface ICardSlipPayment {
  file_path?: string;
  onDownloadFile: () => void;
}

const CardSlipPayment = ({ file_path, onDownloadFile }: ICardSlipPayment) => {
  const { t } = useTranslation();

  return (
    <Box position="relative" width="100%">
      <Card
        sx={{
          marginBottom: 2,
          padding: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {file_path ? (
          <CardMedia
            component="img"
            sx={{ width: 300, height: 500 }} // set your desired width and height here
            image={file_path} // replace with your image URL
            alt="slip payment"
          />
        ) : (
          <div className="column text-center">
            <CardMedia
              component="img"
              sx={{ width: 200, height: 200 }} // set your desired width and height here
              image={alertIcons.errorAlert}
              alt="not file upload"
            />
            <div className="mt-8">not have file upload</div>
          </div>
        )}
      </Card>
      {file_path && (
        <Box
          sx={{
            position: "absolute",
            bottom: 16,
            right: 16, // change to 'left: 50%; transform: translateX(-50%);' for bottom center
          }}
        >
          <Button
            startIcon={<FileDownloadOutlined />}
            variant="contained"
            color="success"
            sx={{ marginBottom: 2 }}
          >
            {t("BUTTON.DOWNLOAD_FILE")}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default CardSlipPayment;
